import RichTextInput from './RichTextInput'

export default RichTextInput
